import { render, staticRenderFns } from "./PreviewSalaryMonthModal.vue?vue&type=template&id=2fc917bb&scoped=true&"
import script from "./PreviewSalaryMonthModal.vue?vue&type=script&lang=js&"
export * from "./PreviewSalaryMonthModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc917bb",
  null
  
)

export default component.exports